import { useRef } from 'react';
import PropTypes from 'prop-types';
import forEach from 'lodash/forEach';

const useFeatures = () => {
  const itemsRef = useRef({});
  const questionsRef = useRef({});
  const featuresRef = useRef({});
  const foundFeatures = useRef({});

  const setFeatures = (app) => {
    itemsRef.current = app.getItems();
    questionsRef.current = app.questions();
    featuresRef.current = app.features();
  };

  const storeMethod = (reference, pause) => {
    if (!foundFeatures.current[reference]) {
      foundFeatures.current[reference] = [];
    }
    foundFeatures.current[reference] = [
      ...foundFeatures.current[reference],
      pause,
    ];
  };

  const pauseSimpleFeatures = (reference, feature) => {
    if (feature && feature.simpleFeatures) {
      const simpleFeatures = feature.simpleFeatures();
      forEach(simpleFeatures, (simpleFeature) => {
        const { pause } = simpleFeature || {};

        if (pause) {
          pause();
          storeMethod(reference, pause);
        }
      });
    }
  };

  const featureCallback = (reference, id, sourceRef) => {
    const feature = sourceRef[id] || {};
    const { pause } = feature;

    pauseSimpleFeatures(reference, feature);

    if (pause) {
      pause();
      storeMethod(reference, pause);
    }
  };

  const stopAudioFeatures = (reference) => {
    const cachedMethods = foundFeatures.current[reference];
    if (cachedMethods) {
      //setTimeout unblocks the thread allowing other events to run
      setTimeout(() => {
        cachedMethods.forEach((pause) => {
          pause();
        });
      }, 0);
      return;
    }
    const item = itemsRef.current[reference];
    if (item) {
      //setTimeout unblocks the thread allowing other events to run
      setTimeout(() => {
        const { response_ids: responseIds, feature_ids: featureIds } = item;
        featureIds.forEach((featureId) =>
          featureCallback(reference, featureId, featuresRef.current),
        );
        responseIds.forEach((responseId) =>
          featureCallback(reference, responseId, questionsRef.current),
        );
      }, 0);
    }
  };

  return { setFeatures, stopAudioFeatures };
};

useFeatures.propTypes = {
  app: PropTypes.object.isRequired,
};

export default useFeatures;
